/**
* Company info
* @author Brendan Magee
*/

function companyService($http, $q) {
  const service = {};
  const endpoint = 'api/company';

  service.get = () => {
    if (service.cache && service.cache.id) {
      return $q.when(service.cache);
    }

    return $http.get(endpoint)
      .then((response) => {
        service.cache = response.data;
        return response.data;
      });
  };

  return service;
}

const serviceArray = [
  '$http',
  '$q',
  companyService
];

module.exports = (ngModule) => {
  ngModule.factory('companyService', serviceArray);
};
